import { TRootState }    from 'Redux/Reducers';
import { arrayContains } from 'Utils';
import Actions           from 'Redux/Actions';

export const isEventParentCategoryLoading = (state: TRootState): boolean =>
  arrayContains(state.eventParentCategory.openRequests, [
    Actions.findEventParentCategoryRequest.type,
    Actions.findEventParentCategoriesRequest.type,
    Actions.createEventParentCategoryRequest.type,
    Actions.updateEventParentCategoryRequest.type,
    Actions.deleteEventParentCategoryRequest.type,
  ]);
